<script lang="ts" setup generic="TValue">
import { computed } from 'vue';

const props = withDefaults(
  defineProps<{
    path?: string;
    value?: TValue | null;
    placeholder?: string;
    loading?: boolean;
    readonly?: boolean;
    disabled?: boolean;
    delimiter?: string;
  }>(),
  {
    readonly: false,
    disabled: false,
    delimiter: ',',
  },
);

const emit = defineEmits<{
  updateField: [value: { path?: string; value: string[] }];
  'update:value': [value: string[]];
}>();

const val = computed(() => (props.value === null ? undefined : props.value));

function handleInput(event: any) {
  const { value } = event.target;

  const list = value.toString().replace(/\s/g, '').split(props.delimiter);

  const uniqueValues = [...new Set(list)] as string[]; // volar snapt niet dat dit een string list is
  emit('updateField', { path: props.path, value: uniqueValues });
  emit('update:value', uniqueValues);
}
</script>

<template>
  <textarea
    class="styled-input min-h-64"
    v-if="!readonly"
    :value="String(val)"
    :placeholder="placeholder"
    @blur="handleInput"
  >
  </textarea>

  <div v-else>{{ val || '-' }}</div>
</template>
